<div class="lv-login-box">
  <div class="lv-login-box__header"></div>
  <form class="lv-login-box__form" (ngSubmit)="requestReset()">
    <div class="lv-login-box__title" translate>forgot-password.title</div>
    <div class="lv-login-box__description" translate>forgot-password.description</div>

    <div class="field">
      <div class="control has-icon">
        <input
          type="email"
          name="email"
          [(ngModel)]="email"
          required
          lvI18nPlaceholder="forgot-password.email-placeholder"
          class="input"
          autocomplete="email"
          [disabled]="loading"
        />
        <span class="icon">
          <i lvIcon="envelope"></i>
        </span>
      </div>
    </div>

    <button class="button" [disabled]="loading" translate>
      {{ loading ? 'app.connecting' : 'forgot-password.submit' }}
    </button>

    <div class="back-to-login">
      <a routerLink="/auth/sign_in" translate>forgot-password.back-to-login</a>
    </div>
  </form>
</div>

<lv-copyright></lv-copyright>
